import { ThemeColors } from '../../../'

export interface ScrollingListColors {
  Background: {
    Default: ThemeColors
  }
  Border: ThemeColors
  Item: {
    Background: {
      Default: ThemeColors
      Hover: ThemeColors
      Active: ThemeColors
    }
  }
}

export const scrollingListColors: ScrollingListColors = {
  Background: {
    Default: {
      default: 'bg.subtle',
    },
  },
  Border: {
    default: 'bg.panel',
  },
  Item: {
    Background: {
      Default: {
        default: 'transparent',
      },
      Hover: {
        default: 'bg.emphasized',
      },
      Active: {
        default: 'bg.muted',
      },
    },
  },
}
